module.exports = __webpack_public_path__ + "img/salon-de-usos-multiples.bdac62e4.svg";